import { createFileRoute } from "@tanstack/react-router";
import FileExplorerPage from "src/components/app/AssetExplorer/FileExplorerPage";
import { DeferredLoaderData } from "src/lib/LoaderData";
import { raceLoaderData } from "src/lib/LoaderResult";
import { scopeFrom } from "src/lib/ScopedLoaders";
import { getFileExplorerData } from "src/server/functions/Portal";

export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/files")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { folderId?: string; view?: "icons" | "details"; q?: string; assetId?: string } => ({
    assetId: typeof search.assetId === "string" ? search.assetId : undefined,
    q: typeof search.q === "string" ? search.q : undefined,
    folderId: typeof search.folderId === "string" ? search.folderId : undefined,
    view: search.view === "icons" || search.view === "details" ? search.view : undefined,
  }),
  // Query-only folder navigation keeps the explorer and its upload queue mounted.
  shouldReload: false,
  loader: (context) =>
    raceLoaderData(
      scopeFrom(context).then(({ projectId }) => {
        const { location } = context;
        return getFileExplorerData({
          data: {
            projectId: projectId ?? "",
            search: new URLSearchParams(location.searchStr).get("q") ?? undefined,
            folderId: new URLSearchParams(location.searchStr).get("folderId") ?? undefined,
          },
        });
      }),
    ),
  component: () => (
    <DeferredLoaderData result={Route.useLoaderData()}>
      {(data) => <FileExplorerPage {...data} />}
    </DeferredLoaderData>
  ),
});
